import React, {createContext, useState, useContext} from 'react';


//This context provider allows the authentication status and current user to be shared across the app
export const HeaderContext = createContext();

export const HeaderContextProvider = ({children}) => {
    const [centeredHeaderContent, setCenteredHeaderContent] = useState('');

    return (
        <HeaderContext.Provider value={
                {
                    centeredHeaderContent,
                    setCenteredHeaderContent
                }
        }>
            {children}
        </HeaderContext.Provider>
    );
};

//Call this hook in any component to access the global authentication status
export const useHeaderContext = () => {
    const context = useContext(HeaderContext);
    if (context === undefined) {
        throw new Error('useHeaderContext must be used within a HeaderContextProvider');
    }
    return context;
};